export default "__VITE_ASSET__D8Mj8gyM__"